import { useKasutajaStore } from '@/stores/kasutajaStore';

const items =
  [
    {
      icon: 'mdi-human',
      title: 'Ligipääsetavus',
      value: 'avaleht_ligipaasetavus',
      route: '/avaleht/ligipaasetavus'
    },
    {
      icon: 'mdi-view-dashboard',
      title: 'Avaleht',
      value: 'avaleht',
      route: '/avaleht',
    },
    {
      icon: 'mdi-email-outline',
      title: 'Pöördumised',
      value: 'poordumised',
      //route: '/poordumised',
    },
    {
      icon: 'mdi-video-outline',
      title: 'Videokohtumine',
      value: 'videokohtumine',
    },
    {
      icon: 'mdi-calendar-month-outline',
      title: 'Minu kalender',
      value: 'minu_kalender',
    },
    {
      icon: 'mdi-gavel',
      title: 'Õigused ja kohustused',
      value: 'oigused_ja_kohustused',
      route: '/oigused_ja_kohustused',
      condition: () => {
        const userStore = useKasutajaStore();
        return userStore.onOigusedJaKohustusedNahtav;
      }
    },
    {
      icon: 'mdi-file-document-outline',
      title: 'Dokumendid',
      value: 'dokumendid',
      route: '/dokumendid',
    },
    {
      icon: 'mdi-file-document-outline',
      title: 'Hoolduskava',
      value: 'hoolduskava',
      route: '/hoolduskava',
      condition: () => {
        const userStore = useKasutajaStore();
        return userStore.onHoolduskavaNahtav;
      }
    },
    {
      icon: 'mdi-clock-time-three-outline',
      title: 'Üldkasulik töö',
      value: 'uldkasulik_too',
      route: '/uldkasulik_too',
      condition: () => {
        const userStore = useKasutajaStore();
        return userStore.onYktNahtav;
      }
    },
    {
      icon: 'mdi-clock-time-three-outline',
      title: 'Elektrooniline valve',
      value: 'elektrooniline_valve',
      route: '/elektrooniline_valve',      
      condition: () => {
        const userStore = useKasutajaStore();
        return userStore.onEvNahtav;
      }
    },
    {
      icon: 'mdi-clock-time-three-outline',
      title: 'Programmid',
      value: 'programmid',
    },
    {
      icon: 'mdi-file-document-outline',
      title: 'Rikkumised',
      value: 'rikkumised',
    },
    {
      icon: 'mdi-account-outline',
      title: 'Minu andmed',
      value: 'minu_andmed',
    },
    {
      icon: 'mdi-help-circle-outline',
      title: 'Abikeskus ehk KKK',
      value: 'abikeskus_ehk_kkk',
    }
  ];

export default items;
